import axios from "axios";
import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";

import PopupCard, { PopupCardName } from "../../components/PopupCard";
import LoginForm from "./LoginForm";
import Register from "./RegisterForm";
import SocialButton from "components/SocialButton";

const LoginPage: React.FC = () => {
  const [isShowLoginForm, setIsShowLoginForm] = useState(false);
  const [isRegister, setIsRegister] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [popup, setPopup] = useState<{
    name: PopupCardName;
    status: "success" | "failed";
    text: React.ReactNode;
    redirectTo?: string;
  } | null>(null);

  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");

  // Kiểm tra token khi component mount
  useEffect(() => {
    const token = Cookies.get("access_token");
    const userInfo = localStorage.getItem("user_info");

    // Nếu đã có token và user info, redirect ngay
    if (token && userInfo) {
      try {
        const user = JSON.parse(userInfo);
        if (user.role === "SUPERADMIN" || user.role === "ADMIN") {
          window.location.href = "/admin";
        } else {
          window.location.href = "/";
        }
      } catch (e) {
        // Nếu parse lỗi, clear và ở lại trang login
        Cookies.remove("access_token");
        localStorage.removeItem("user_info");
      }
    }
  }, []);

  useEffect(() => {
    if (!popup?.redirectTo) {
      return;
    }

    const { redirectTo } = popup;

    const timeoutId = window.setTimeout(() => {
      window.location.href = redirectTo;
    }, 500);

    return () => {
      window.clearTimeout(timeoutId);
    };
  }, [popup]);

  const handleLogin = async (e?: React.FormEvent) => {
    // Prevent default form submission
    if (e) {
      e.preventDefault();
    }

    if (userName.trim() === "" || password.trim() === "") {
      setPopup({
        name: PopupCardName.Login,
        status: "failed",
        text: "Vui lòng điền đầy đủ thông tin",
      });
      return;
    }

    try {
      await new Promise((resolve) => setTimeout(resolve, 1000));

      const data = await axios.post(
        `${process.env.REACT_APP_URL_API}/auth/login`,
        {
          username: userName,
          password,
        },
      );

      // Persist session info before navigating so route guards see it immediately
      localStorage.setItem(
        "user_info",
        JSON.stringify({
          userName: data.data.user.username,
          coins: data.data.user.coins,
          role: data.data.user.role,
          id: data.data.user._id,
        }),
      );

      // Some parts still read token from localStorage; keep in sync
      localStorage.setItem("access_token", data.data.access_token);

      // Only set secure cookie on HTTPS; in dev (http) secure cookies are ignored
      const isSecure = window.location.protocol === "https:";
      Cookies.set("access_token", data.data.access_token, {
        expires: 1 / 24,
        secure: isSecure,
        sameSite: "Strict",
      });

      // Đóng tất cả modals ngay lập tức
      setIsShowLoginForm(false);
      setIsRegister(false);

      if (
        (data.status === 201 && data.data.user.role === "SUPERADMIN") ||
        data.data.user.role === "ADMIN"
      ) {
        setPopup({
          name: PopupCardName.Login,
          status: "success",
          text: (
            <>
              ĐĂNG NHẬP THÀNH CÔNG!
              <br />
              CHÀO MỪNG ADMIN TRỞ LẠI!
            </>
          ),
          redirectTo: "/admin",
        });
      } else {
        setPopup({
          name: PopupCardName.Login,
          status: "success",
          text: (
            <>
              ĐĂNG NHẬP THÀNH CÔNG!
              <br />
              ĐANG CHUYỂN HƯỚNG...
            </>
          ),
          redirectTo: "/",
        });
      }
    } catch (err: any) {
      const status = err?.response?.status;
      if (status === 401) {
        setPopup({
          name: PopupCardName.Login,
          status: "failed",
          text: "Tài khoản/mật khẩu không chính xác!",
        });
        return;
      }
      setPopup({
        name: PopupCardName.Login,
        status: "failed",
        text: "Đăng nhập thất bại, vui lòng thử lại.",
      });
    }
  };

  return (
    <div className="flex flex-col items-center justify-center gap-6 md:px-32 px-6 w-full h-screen">
      {/* body */}
      <img className="w-[400px]" src="/assets/common/logo.png" alt="Logo" />
      <div className="flex flex-col items-center gap-2 md:flex-row md:justify-center md:gap-3">
        <button
          className="w-2/3 md:w-auto"
          type="button"
          onClick={() => {
            setIsShowLoginForm(true);
            setIsRegister(false);
          }}
        >
          <img src="/assets/common/btn-login.png" alt="ĐĂNG NHẬP" />
        </button>
        <button
          className="w-2/3 md:w-auto"
          type="button"
          onClick={() => {
            setIsRegister(true);
            setIsShowLoginForm(false);
          }}
        >
          <img src="/assets/common/btn-register.png" alt="ĐĂNG KÝ" />
        </button>
      </div>
      <img
        // className="w-1/3 md:w-full"
        src="/assets/common/banner.png"
        alt="banner"
      />

      {/* POPUP */}

      {isShowLoginForm && (
        <LoginForm
          onClose={() => setIsShowLoginForm(false)}
          userName={userName}
          password={password}
          showPassword={showPassword}
          onSubmit={handleLogin}
          onUserNameChange={setUserName}
          onPasswordChange={setPassword}
          onToggleShowPassword={() => setShowPassword((v) => !v)}
          onToggleRegister={() => {
            setIsRegister(true);
            setIsShowLoginForm(false);
          }}
        />
      )}

      {isRegister && (
        <Register
          onError={(message) =>
            setPopup({
              name: PopupCardName.Register,
              status: "failed",
              text: message,
            })
          }
          onSuccess={(message) =>
            setPopup({
              name: PopupCardName.Register,
              status: "success",
              text: message,
            })
          }
          isRegister={isRegister}
          setIsShowLogin={() => {
            setIsShowLoginForm(true);
            setIsRegister(false);
          }}
          setIsRegister={() => setIsRegister(false)}
        />
      )}

      {popup && (
        <PopupCard
          name={popup.name}
          status={popup.status}
          text={popup.text}
          onClose={() => setPopup(null)}
        />
      )}
      {/* LEFT BTN */}
      <div className="hidden md:block fixed bottom-28 left-14">
        <SocialButton />
      </div>
    </div>
  );
};

export default LoginPage;
